(function() {
  'use strict';

  var dataEl = document.getElementById('bulk-purchasing-data');
  if (!dataEl) return;

  var config;
  try {
    config = JSON.parse(dataEl.textContent);
  } catch (e) {
    return;
  }

  // config.override (custom.twelve_week_product): the card sells that
  // product's 12-week variant at its own price instead of this product in bulk.
  var override = config.override || null;
  if (!config.enabled || (!override && (!config.quantity || !config.discountPercent))) return;

  var POLL_INTERVAL = 300;
  var MAX_POLLS = 30;

  function formatMoney(cents) {
    var amount = (cents / 100).toFixed(2);
    return '€' + amount;
  }

  function getUnitPrice() {
    // Try to get the current variant price from the one-time price element
    var oneTimeMoney = document.querySelector('.sls-one-time-price .money');
    if (oneTimeMoney) {
      // Parse the displayed price back to cents
      var text = oneTimeMoney.textContent.trim();
      var cleaned = text.replace(/[^0-9.,]/g, '').replace(',', '.');
      var parsed = parseFloat(cleaned);
      if (!isNaN(parsed)) return Math.round(parsed * 100);
    }
    return config.unitPrice;
  }

  // What the card shows: the struck-through price, the price paid and the
  // badge percentage. The override's "was" price is its compare-at price,
  // else what the same number of boxes of this product would cost.
  function cardPrices() {
    var unitPrice = getUnitPrice();
    if (override) {
      var full = override.compareAtPrice || unitPrice * config.quantity;
      var percent = full > override.price ? Math.round((1 - override.price / full) * 100) : 0;
      return { full: full, discounted: override.price, percent: percent };
    }
    var totalFull = unitPrice * config.quantity;
    return {
      full: totalFull,
      discounted: Math.round(totalFull * (1 - config.discountPercent / 100)),
      percent: config.discountPercent
    };
  }

  function createBulkOption() {
    var prices = cardPrices();

    var container = document.createElement('div');
    container.className = 'sls-option-container seal-table bulk-purchasing-option';
    container.setAttribute('data-bulk-purchasing', 'true');

    // perShotLabel carries its own separator (e.g. "/dag"), so no space before it
    var perShotHtml = '';
    if (config.perShotPrice) {
      perShotHtml = '<div class="bulk-purchasing-per-shot">' + formatMoney(config.perShotPrice) + (config.perShotLabel || '') + '</div>';
    }

    // Optional card image (custom.pdp_card_image_90_day) sits beside the
    // bullets, same structure as the Seal cards get from main-product.liquid.
    var imageHtml = '';
    if (config.cardImage) {
      imageHtml = '<img class="pdp-card-media__img" src="' + config.cardImage + '"' +
        (config.cardImage2x ? ' srcset="' + config.cardImage + ' 1x, ' + config.cardImage2x + ' 2x"' : '') +
        ' alt="' + String(config.cardImageAlt || '').replace(/"/g, '&quot;') + '" width="65" height="65" loading="lazy">';
    }
    var descriptionHtml = '';
    if (config.cardDescription || imageHtml) {
      descriptionHtml = '<div class="bulk-purchasing-description' + (imageHtml ? ' pdp-card-media' : '') + '">' +
        imageHtml + (config.cardDescription ? '<div class="bulk-purchasing-description__text">' + config.cardDescription + '</div>' : '') +
        '</div>';
    }

    container.innerHTML =
      '<label class="bulk-purchasing-label" style="display:flex;align-items:center;gap:8px;cursor:pointer;width:100%!important;padding:0;">' +
        '<input type="radio" name="bulk-purchase-radio" class="bulk-purchasing-radio" data-type="bulk_purchase" style="display:none;">' +
        '<span class="bulk-purchasing-radio-dot"></span>' +
        '<span class="bulk-purchasing-content" style="display:flex;justify-content:space-between;align-items:center;flex:1;min-width:0;">' +
          '<label class="bulk-purchasing-name">' + (config.label || config.quantity + ' boxes') + '&nbsp;<span class="bulk-purchasing-badge" style="display:' + (prices.percent ? 'inline-block' : 'none') + ';">-' + prices.percent + '%</span></label>' +
          '<span class="bulk-purchasing-prices" style="display:flex;flex-direction:column;align-items:flex-end;">' +
            '<span style="display:flex;align-items:center">' +
              '<div class="bulk-purchasing-original"' + (prices.full > prices.discounted ? '' : ' style="display:none;"') + '><span class="bulk-purchasing-original-money">' + formatMoney(prices.full) + '</span></div>' +
              '<span class="bulk-purchasing-discounted"><span class="bulk-purchasing-discounted-money">' + formatMoney(prices.discounted) + '</span></span>' +
            '</span>' +
            perShotHtml +
          '</span>' +
        '</span>' +
      '</label>' +
      descriptionHtml;

    return container;
  }

  function getQuantityInput() {
    return document.querySelector('input[name="quantity"]');
  }

  function getButtonPrice() {
    return document.querySelector('[data-product-price]');
  }

  function getFormSellingPlanInput() {
    var form = document.querySelector('form[data-type="add-to-cart-form"]');
    return form ? form.querySelector('input[name="selling_plan"]') : null;
  }

  // The add-to-cart forms for this product (main and sticky), not the
  // product cards further down the page, which use the same data-type.
  function getProductForms() {
    var main = document.querySelector('form[data-type="add-to-cart-form"]');
    if (!main) return [];
    var productId = main.querySelector('input[name="product-id"]');
    if (!productId) return [main];
    return Array.prototype.filter.call(document.querySelectorAll('form[data-type="add-to-cart-form"]'), function(form) {
      var id = form.querySelector('input[name="product-id"]');
      return id && id.value === productId.value;
    });
  }

  // The override variant is only put on the form while it submits. Seal
  // watches the form's variant id: given one it has no plans for, it
  // re-renders to one-time purchase, which deselects the 12-week card. A
  // window capture listener runs before the cart drawer's document capture
  // listener reads the form; the values go back straight after.
  function swapForSubmit(form) {
    var changed = [];
    function set(input, value) {
      changed.push([input, input.value]);
      input.value = value;
    }
    var idInput = form.querySelector('input[name="id"]');
    if (idInput) set(idInput, override.variantId);
    var qtyInput = form.querySelector('input[name="quantity"]');
    if (qtyInput) set(qtyInput, 1);
    var planInput = form.querySelector('input[name="selling_plan"]');
    var addedPlan = null;
    if (!planInput && override.sellingPlanId) {
      planInput = addedPlan = document.createElement('input');
      planInput.type = 'hidden';
      planInput.name = 'selling_plan';
      form.appendChild(planInput);
    }
    if (planInput) {
      set(planInput, override.sellingPlanId || '');
      planInput.disabled = false;
    }
    setTimeout(function() {
      changed.forEach(function(entry) { entry[0].value = entry[1]; });
      if (addedPlan) addedPlan.remove();
    }, 0);
  }

  function watchSubmit(bulkContainer) {
    window.addEventListener('submit', function(event) {
      // a product swap re-runs this file; the old card is then detached
      if (!bulkContainer.isConnected || !bulkContainer.classList.contains('sls-active')) return;
      var form = event.target;
      if (getProductForms().indexOf(form) === -1) return;
      swapForSubmit(form);
    }, true);
  }

  function removeSellingPlanInput() {
    var sellingPlanInput = getFormSellingPlanInput();
    if (sellingPlanInput) {
      sellingPlanInput.value = '';
    }
  }

  // Selecting bulk only blanks the form's copy of selling_plan; Seal's own
  // state still holds the plan. Clicking that plan again is a no-op for Seal
  // (nothing changed from its point of view), so it never re-writes the form
  // input and the add would post quantity 1 with no plan, i.e. a one-time
  // purchase. Re-sync the form from Seal whenever a Seal option is picked.
  function restoreSellingPlanInput(container) {
    var sellingPlanInput = getFormSellingPlanInput();
    if (!sellingPlanInput) return;
    var sealInput = document.querySelector('input[data-sls-selling_plan]');
    var value = sealInput ? sealInput.value : '';
    if (!value && container && !container.querySelector('.sls-option[data-type="one_time"]')) {
      var select = container.querySelector('select[name="subs_interval"]');
      if (select) value = select.value;
    }
    sellingPlanInput.value = value;
  }

  function deselectSealOptions() {
    var sealContainers = document.querySelectorAll('.sls-option-container:not(.bulk-purchasing-option)');
    sealContainers.forEach(function(c) {
      c.classList.remove('sls-active');
    });
    var sealRadios = document.querySelectorAll('.sls-option:not(.bulk-purchasing-radio)');
    sealRadios.forEach(function(r) {
      r.checked = false;
    });
  }

  function deselectBulkOption(bulkContainer) {
    bulkContainer.classList.remove('sls-active');
    var radio = bulkContainer.querySelector('.bulk-purchasing-radio');
    if (radio) radio.checked = false;
  }

  function selectBulkOption(bulkContainer) {
    var totalDiscounted = cardPrices().discounted;

    deselectSealOptions();
    bulkContainer.classList.add('sls-active');
    var radio = bulkContainer.querySelector('.bulk-purchasing-radio');
    if (radio) radio.checked = true;

    // the override's form values are set on submit (watchSubmit)
    if (!override) {
      var qtyInput = getQuantityInput();
      if (qtyInput) qtyInput.value = config.quantity;
      removeSellingPlanInput();
    }

    var buttonPrice = getButtonPrice();
    if (buttonPrice) buttonPrice.textContent = formatMoney(totalDiscounted);

    // Dispatch event so other scripts know bulk is active
    document.dispatchEvent(new CustomEvent('bulk-purchase:selected', {
      detail: { price: totalDiscounted, quantity: override ? 1 : config.quantity }
    }));
  }

  function updateBulkPrices(bulkContainer) {
    var prices = cardPrices();
    var totalDiscounted = prices.discounted;

    var originalEl = bulkContainer.querySelector('.bulk-purchasing-original-money');
    if (originalEl) {
      originalEl.textContent = formatMoney(prices.full);
      originalEl.parentNode.style.display = prices.full > prices.discounted ? '' : 'none';
    }

    var discountedEl = bulkContainer.querySelector('.bulk-purchasing-discounted-money');
    if (discountedEl) discountedEl.textContent = formatMoney(totalDiscounted);

    var badgeEl = bulkContainer.querySelector('.bulk-purchasing-badge');
    if (badgeEl) {
      badgeEl.textContent = '-' + prices.percent + '%';
      badgeEl.style.display = prices.percent ? 'inline-block' : 'none';
    }

    if (config.perShotPrice) {
      var perShotEl = bulkContainer.querySelector('.bulk-purchasing-per-shot');
      if (perShotEl) perShotEl.textContent = formatMoney(config.perShotPrice) + (config.perShotLabel || '');
    }

    // If bulk is currently active, update button price too
    if (bulkContainer.classList.contains('sls-active')) {
      var buttonPrice = getButtonPrice();
      if (buttonPrice) buttonPrice.textContent = formatMoney(totalDiscounted);
    }
  }

  function createSeparator() {
    var separator = document.createElement('div');
    separator.className = 'bulk-purchasing-separator';
    separator.innerHTML = '<span>or</span>';
    return separator;
  }

  function reorderOptions(optionsContainer, bulkContainer) {
    // Find the one-time option (has a radio with data-type="one_time")
    var oneTimeOption = null;
    var subscriptionOptions = [];
    var sealContainers = optionsContainer.querySelectorAll('.sls-option-container:not(.bulk-purchasing-option)');

    sealContainers.forEach(function(container) {
      var radio = container.querySelector('.sls-option[data-type="one_time"]');
      if (radio) {
        oneTimeOption = container;
      } else {
        subscriptionOptions.push(container);
      }
    });

    // Re-insert in order: subscription(s) first, then separator, then one-time, then bulk
    subscriptionOptions.forEach(function(sub, i) {
      if (i === 0) {
        optionsContainer.insertBefore(sub, optionsContainer.firstChild);
      } else {
        optionsContainer.insertBefore(sub, subscriptionOptions[i - 1].nextSibling);
      }
    });

    // Bulk goes after subscriptions
    optionsContainer.appendChild(bulkContainer);

    // Add "or" separator
    var separator = createSeparator();
    optionsContainer.appendChild(separator);

    // One-time goes last, after separator
    if (oneTimeOption) {
      optionsContainer.appendChild(oneTimeOption);
    }
  }

  function injectSealPerShotPrices(optionsContainer) {
    var sealContainers = optionsContainer.querySelectorAll('.sls-option-container:not(.bulk-purchasing-option)');
    sealContainers.forEach(function(container) {
      var radio = container.querySelector('.sls-option[data-type="one_time"]');
      var perShotValue = radio ? config.perShotPriceSingle : config.perShotPriceSub;
      if (!perShotValue) return;

      var priceContainer = container.querySelector('.sls-price-container');
      if (!priceContainer) return;

      // Skip if already injected
      if (priceContainer.querySelector('.bulk-purchasing-per-shot')) return;

      var perShotEl = document.createElement('div');
      perShotEl.className = 'bulk-purchasing-per-shot';
      perShotEl.textContent = formatMoney(perShotValue) + (config.perShotLabel || '');
      priceContainer.appendChild(perShotEl);
    });
  }

  function forceShowDescriptions(container) {
    var descriptions = container.querySelectorAll('[class*="description"]');
    descriptions.forEach(function(d) {
      d.style.display = '';
    });
  }

  function observeSealChanges(optionsContainer) {
    var priceObserver = new MutationObserver(function() {
      injectSealPerShotPrices(optionsContainer);
    });

    var classObserver;

    function attachClassObserver() {
      if (classObserver) classObserver.disconnect();
      classObserver = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
          if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
            var container = mutation.target;
            if (container.classList.contains('sls-active')) {
              forceShowDescriptions(container);
            }
          }
        });
      });
      var sealContainers = optionsContainer.querySelectorAll('.sls-option-container:not(.bulk-purchasing-option)');
      sealContainers.forEach(function(container) {
        classObserver.observe(container, { attributes: true, attributeFilter: ['class'] });
        var priceContainer = container.querySelector('.sls-price-container');
        if (priceContainer) {
          priceObserver.observe(priceContainer, { childList: true, subtree: true });
        }
      });
    }

    attachClassObserver();

    // Re-attach observers when Seal re-renders its option containers
    var rerenderObserver = new MutationObserver(function() {
      attachClassObserver();
      var sealContainers = optionsContainer.querySelectorAll('.sls-option-container:not(.bulk-purchasing-option)');
      sealContainers.forEach(function(container) {
        if (container.classList.contains('sls-active')) {
          forceShowDescriptions(container);
        }
      });
    });
    rerenderObserver.observe(optionsContainer, { childList: true });
  }

  function init() {
    var pollCount = 0;

    function poll() {
      var optionsContainer = document.querySelector('.sls-purchase-options-container');
      if (!optionsContainer) {
        pollCount++;
        if (pollCount < MAX_POLLS) {
          setTimeout(poll, POLL_INTERVAL);
        }
        return;
      }

      var bulkContainer = createBulkOption();
      optionsContainer.appendChild(bulkContainer);
      if (override) watchSubmit(bulkContainer);

      // Inject per-shot prices on Seal options and watch for Seal re-renders
      injectSealPerShotPrices(optionsContainer);
      observeSealChanges(optionsContainer);

      // Reorder: subscription first, bulk second, separator, one-time last
      reorderOptions(optionsContainer, bulkContainer);

      // Click handler for bulk option
      bulkContainer.addEventListener('click', function(e) {
        e.preventDefault();
        selectBulkOption(bulkContainer);
      });

      // Watch for Seal Subscriptions options being clicked — deselect bulk
      var sealContainer = document.querySelector('.sealsubs-container');
      if (sealContainer) {
        sealContainer.addEventListener('click', function(e) {
          // Only react if a Seal option was clicked (not our bulk option)
          var target = e.target;
          if (target.closest('.bulk-purchasing-option')) return;

          var clickedContainer = target.closest('.sls-option-container:not(.bulk-purchasing-option)');

          setTimeout(function() {
            deselectBulkOption(bulkContainer);
            var qtyInput = getQuantityInput();
            if (qtyInput) qtyInput.value = 1;
            restoreSellingPlanInput(clickedContainer);

            // If Seal didn't re-add sls-active to the clicked container, do it ourselves
            if (clickedContainer && !clickedContainer.classList.contains('sls-active')) {
              var allSeal = optionsContainer.querySelectorAll('.sls-option-container:not(.bulk-purchasing-option)');
              allSeal.forEach(function(c) { c.classList.remove('sls-active'); });
              clickedContainer.classList.add('sls-active');
            }
            if (clickedContainer) {
              forceShowDescriptions(clickedContainer);
            }
          }, 100);
        });

        // Also watch radio change events
        var sealRadios = sealContainer.querySelectorAll('.sls-option:not(.bulk-purchasing-radio)');
        sealRadios.forEach(function(radio) {
          radio.addEventListener('change', function() {
            deselectBulkOption(bulkContainer);
            var qtyInput = getQuantityInput();
            if (qtyInput) qtyInput.value = 1;
            restoreSellingPlanInput(radio.closest('.sls-option-container'));
          });
        });
      }

      // Watch for variant changes to recalculate prices
      document.addEventListener('variant:change', function(e) {
        if (e.detail && e.detail.variant && e.detail.variant.price) {
          config.unitPrice = e.detail.variant.price;
          // Wait briefly for Seal Subscriptions to update its prices
          setTimeout(function() {
            updateBulkPrices(bulkContainer);
          }, 200);
        }
      });
    }

    poll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
